import { GB } from './strings';

export const ADDRESS_BOOK_INITIAL_FORM_VALUES = {
  address: {
    addressId: '',
    countryCode: GB,
    postcode: '',
    organisation: '',
    county: '',
    town: '',
    street: '',
    locality: '',
  },
  contactName: '',
  nickname: '',
  email: '',
  phoneNumber: '',
  vatNumber: '',
  eoriNumber: '',
  pidNumber: '',
  ukimsNumber: '',
  isDefault: false,
  isBilling: false,
};
